module.exports = __webpack_public_path__ + "static/media/mono_sound_architecture.d5f5e94a.png";